/**
 * Canonical £ formatters for the forecast / target surfaces.
 *
 * Five copies of `fmtK` / `fmtM` accreted across the forecasting pages
 * before this lived as one helper. Behavioural rules:
 * - 0 → "—" (the operational convention across the workspace; a literal
 *   "£0" reads as deliberately-zero and is too easy to confuse with
 *   "we don't know")
 * - negatives carry a leading minus
 * - `fmtK` always rounds to the nearest £k
 * - `fmtM` rounds to two decimals at ≥£1m, otherwise delegates to fmtK
 *
 * Chart-internal formatters (e.g. Recharts tooltips) may want "£0"
 * instead of "—"; those keep their own inline variant.
 */

export function fmtK(n: number): string {
  if (!Number.isFinite(n) || n === 0) return "—";
  const sign = n < 0 ? "-" : "";
  return `${sign}£${Math.round(Math.abs(n) / 1000)}k`;
}

export function fmtM(n: number): string {
  if (!Number.isFinite(n) || n === 0) return "—";
  if (Math.abs(n) >= 1_000_000) {
    const sign = n < 0 ? "-" : "";
    return `${sign}£${(Math.abs(n) / 1_000_000).toFixed(2)}m`;
  }
  return fmtK(n);
}
